import {
  Pill, ShieldPlus, HeartPulse, FlaskConical, Leaf, Sparkles, Stethoscope, PawPrint, Syringe, Microscope, Dna,
  Baby, Eye, Brain, Bone, Droplets, Thermometer, Activity, Package, Apple, Salad, TestTube, Tablets, BriefcaseMedical,
  Ear, Hospital, Heart, Smile,
} from "lucide-react";

// Icons an admin can pick for a product category (stored by name).
export const CATEGORY_ICONS = {
  Pill, Tablets, Syringe, ShieldPlus, HeartPulse, Heart, FlaskConical, TestTube, Microscope, Dna, Leaf, Salad, Apple,
  Sparkles, Smile, Stethoscope, BriefcaseMedical, Hospital, PawPrint, Baby, Eye, Ear, Brain, Bone, Droplets, Thermometer,
  Activity, Package,
};

// Icons used before categories became editable (matched by name)
export const LEGACY_CATEGORY_ICONS = {
  "Prescription Medicines": Pill,
  "OTC Products": ShieldPlus,
  "Nutraceuticals": HeartPulse,
  "Dietary Supplements": FlaskConical,
  "Herbal Products": Leaf,
  "Cosmetics": Sparkles,
  "Medical Devices": Stethoscope,
  "Veterinary Products": PawPrint,
};

export const categoryIcon = (c) => CATEGORY_ICONS[c?.icon] || LEGACY_CATEGORY_ICONS[c?.name] || Package;
